<template>     
    <TablePricesComponent :key="reloadComponent">
        <template #buttons>
            <Button @click="showModal('crearPrecio')">Crear nuevo tipo de abono</Button>
            <CreatePrecioSinRecintoModal :lista_id="lista_id" @close="closeModal" />
        </template>
        <template #editarPrecio="{ index, tipo }">
            <EditPrecioSinRecintoModal :key="index + '-'" :precio="tipo" :lista_id="lista_id" @close="closeModal" />
        </template>
    </TablePricesComponent>
</template>

<script>
    import TablePricesComponent from './components/TablePricesComponent.vue';
    import CreatePrecioSinRecintoModal from '../modals/CreatePrecioSinRecintoModal.vue';
    import EditPrecioSinRecintoModal from '../modals/EditPrecioSinRecintoModal.vue';

    export default {
        data() {
            return {
                reloadComponent: 1
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);

                if(creado) {
                    this.reloadComponent++;
                }
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaAbonados.id
            }
        },
        components: {
            TablePricesComponent, CreatePrecioSinRecintoModal, EditPrecioSinRecintoModal
        }
    }
</script>
